package com.writerslab

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.StyleScope
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLDivElement

@JsModule("marked")
@JsNonModule
private external object MarkedLib {
    fun parse(content: String): String
}

fun renderMarkdown(source: String): String =
    runCatching { MarkedLib.parse(source) }.getOrElse { escapeHtml(source) }

private fun escapeHtml(s: String): String =
    s.replace("&", "&amp;").replace("<", "&lt;").replace(">", "&gt;")

/**
 * Render markdown to a `<div>` via marked.js, injecting the resulting HTML
 * with `innerHTML`. Safe because the source is the model's own report text
 * we already trust; marked sanitises HTML by default in v12.
 */
@Composable
fun MarkdownBlock(
    source: String,
    attrs: (AttrsScope<HTMLDivElement>.() -> Unit)? = null,
) {
    val html = renderMarkdown(source)
    Div({
        attrs?.invoke(this)
        ref { node ->
            node.innerHTML = html
            onDispose { node.innerHTML = "" }
        }
    })
}

fun StyleScope.markdownTheme() {
    property("color", WLColors.OnSurface)
    property("line-height", "1.55")
    property("word-break", "break-word")
}
